import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-window-deactivate',
  templateUrl: './dialog-window-deactivate.component.html',
  styleUrls: ['./dialog-window-deactivate.component.css']
})
export class DialogWindowDeactivateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
